import { ICommandBarItemProps } from "@fluentui/react";
import { RouterParams } from "App";
import { RootState } from "app/store";
import { emitCustomEvent } from "global/Application";
import { useApplication } from "global/Application/Context";
import { loadCheckListAction } from "global/Application/dataActions";
import { endSnapshotLoad, startSnapshotLoad } from "global/Reducer/statusSlice";
import { IApplicationMenu } from "model/Application";
import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import ConfirmationDialog from "../ConfirmationDialog";
import GroupConfigurationSnapshotContext from "../GroupConfigurationSnapshotContext";
import CheckListBrowser from "./CheckListBrowser";
import { ICheckListProps } from "./ICheckListProps";


const CheckList = (props: ICheckListProps) => {
    const { planId, } = useParams<RouterParams>();

    const dispatch = useDispatch();
    const application = useApplication();

    const [hiddenSendNotification, setHiddenSendNotification] = useState(true);

    const state = useSelector((state: RootState) => state);

    const contextMenu = useMemo(() => {

        const items: ICommandBarItemProps[] = [];

        items.push({
            key: 'refresh',
            text: 'Refresh',
            title: 'Refresh',
            iconProps: { iconName: 'Refresh' },
            onClick: (ev, item) => {
                dispatch(loadCheckListAction(application.dataSource));
            }
        });

        items.push({
            key: 'notify',
            text: 'Send Notifications',
            title: 'Send Notifications',
            disabled: !state?.data?.checkList?.some(t => !!t.bcbs_emchecklist.bcbs_sendnotificationcode),
            iconProps: { iconName: 'Send' },
            onClick: (ev, item) => {

                // TODO make available only to following processes:
                (async () => {
                    try {
                        dispatch(startSnapshotLoad());
                        await application.dataSource.bcbs_emchecklists_executeNotifications(state.data.snapshot);
                        setHiddenSendNotification(false);
                    } catch (error) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: error
                        });

                    } finally {
                        dispatch(endSnapshotLoad());
                    }
                })();

            }
        });

        const contextMenu: IApplicationMenu = {
            items: items,
            key: 'checklist'
        };

        return contextMenu;

    }, [state.data.snapshot, state?.data?.checkList]);

    const renderCheckListPlanBrowser = () => {
        if (planId)
            return <></>;

        return <CheckListBrowser />;
    }

    const renderConfirmationDialog = () => {
        return (
            <ConfirmationDialog
                title="Action Complete"
                hidden={hiddenSendNotification}
                message="A notification dispatch process has been initiated. Please be advised that there may be a delay before the process is executed."
                actions={[
                    {
                        name: 'Close',
                        onClick: () => {
                            setHiddenSendNotification(true);
                        }
                    }
                ]}
            />
        );
    }

    return (
        <GroupConfigurationSnapshotContext
            contextMenu={contextMenu}
            isChecklist={true}
        >
            {renderConfirmationDialog()}
            {renderCheckListPlanBrowser()}
        </GroupConfigurationSnapshotContext>
    );
}

export default CheckList;